import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import PureComponent from '../../../lib/preact-pure-component'

interface Props {
  addIntersectionElement: (el: HTMLDivElement) => void
  id: string
  source?: string
}

export class Timing extends PureComponent<Props, {}> {
  tail?: HTMLDivElement

  componentDidMount() {
    const { addIntersectionElement } = this.props
    if (this.tail) {
      addIntersectionElement(this.tail)
    }
  }
  render() {
    const { source, id } = this.props
    if (source) {
      return <div ref={tail => (this.tail = tail)} className={style.tail} id={`${id}-tail`} />
    }
    return null
  }
}
